import { HttpApplication } from '../../http';

import { type Taxpayers } from './TaxpayerRequest/types';

/**
 * Recupera la información de registro de un contribuyente en particular.
 * Dicha recuperación se realiza utilizado el identificador asignado (TIN)
 * al contribuyente
 *
 * @param {string} nit identificador del contribuyente
 * @return {*}  {Promise<Taxpayers>} Información del contribuyente consultado
 */
export const getTaxpayerByNit = (tin: string): Promise<Taxpayers> => {
  return HttpApplication.get<Taxpayers>(`/taxpayers/byNit/${tin}`);
};

/**
 * Recupera la lista de contribuyentes cuyo identificador o nombre
 * contienen el texto recibido
 *
 * @param {string} value Texto a ser buscado dentro de las propiedades
 * de nombre e identificación del contribuyente
 * @return {*}  {Promise<Taxpayers[]>} Lista de contribuyentes que
 * cumplen la condición especificada
 */
export const searchTaxpayer = (value: string): Promise<Array<Taxpayers>> => {
  return HttpApplication.get<Array<Taxpayers>>(`/taxpayers/search/${value}`);
};
